import * as React from 'react'
import { Card, CardBody } from '../card'
import { HTMLEvent } from '../../lib/utils'
import styles from './formCard.module.scss'

interface IFormCardProps {
  header?: React.ReactNode
  inputs: { key: string | number | null; node: React.ReactNode | null }[]
  button?: React.ReactNode | null
  col?: 1 | 2 | 3
  style?: React.CSSProperties
  onSubmit?: (e: HTMLEvent) => void
  extra?: React.ReactNode
  className?: string
  error?: string | React.ReactNode
  success?: string | React.ReactNode
}

export default function FormCard({
  header,
  inputs,
  button,
  col = 1,
  style,
  onSubmit,
  extra,
  className,
  error,
  success,
}: IFormCardProps) {
  return (
    <div className={className} style={style}>
      <Card className={styles.formCard}>
        {header && <div className={styles.formCardHeader}>{header}</div>}
        <CardBody className={styles.formCardBody}>
          {onSubmit ? (
            <form
              onSubmit={(e: HTMLEvent) => {
                onSubmit(e)
              }}
            >
              <div className={styles.inputsWrapper}>
                {inputs.map((input) =>
                  input.node && input.key ? (
                    <div
                      className={styles.inputWrapper}
                      key={input.key}
                      style={{ width: col > 1 ? `calc(100% / ${col} - 1rem)` : '100%' }}
                    >
                      {input.node}
                    </div>
                  ) : null
                )}
              </div>
              {error && <div className={styles.errorWrapper}>{error}</div>}
              {success && <div className={styles.successWrapper}>{success}</div>}
              {button}
            </form>
          ) : (
            <>
              <div className={styles.inputsWrapper}>
                {inputs.map((input) =>
                  input.node && input.key ? (
                    <div
                      className={styles.inputWrapper}
                      key={input.key}
                      style={{ width: col > 1 ? `calc(100% / ${col} - 1rem)` : '100%' }}
                    >
                      {input.node}
                    </div>
                  ) : null
                )}
              </div>
              {error && <div className={styles.errorWrapper}>{error}</div>}
              {button}
            </>
          )}
          {extra}
        </CardBody>
      </Card>
    </div>
  )
}
